// extracted by mini-css-extract-plugin
export default {"container":"SectionHeading_container__saEY7"};